<template>
  <span/>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RolesMixin',
  computed: {
    ...mapGetters(['rolesFetched', 'user', 'roles', 'perms', 'tenants']),
  },
  async created() {
    const routeName = this.$route.name.toLowerCase();
    if (!this.rolesFetched || !Object.keys(this.roles).length) {
      if (routeName.includes('admin')) {
        await this.$store.dispatch('getAdminRoles');
        this.loadedRoles = true;
      } else if (routeName.includes('partner')) {
        await this.$store.dispatch('getPartnerRoles');
        this.loadedRoles = true;
      } else {
        console.log('RolesMixin: No roles fetched, routeName:', routeName);
      }
    } else {
      this.loadedRoles = true;
    }
  },
  data() {
    return {
      loadedRoles: false,
    };
  },
  methods: {
    havePerm(_permissions = []) {
      const user = this.user;
      const roles = this.roles;
      if (!user?._id) {
        return false;
      }
      if (_permissions.length == 0) {
        return true;
      }

      const _roles = user.roles;
      for (let i = 0; i < _roles.length; i++) {
        const role = roles[_roles[i].name];
        const havePerm = _permissions.every(p => { return role.includes(p) });
        if (havePerm) {
          return true;
        }
      }
      return false;
    },
    haveTenant(_roles = [], _tenant) {
      const tenants = this.tenants;

      for (let i = 0; i < _roles.length; i++) {
        const tenant = tenants[_roles[i].tenant];
        if (tenant == _tenant) {
          return true;
        }
      }
      return false;
    },
  }
};
</script>
